import { Textarea } from '@mantine/core';
import { CommonInputProps } from './DataInputField';

type DataInputTextareaProps = CommonInputProps & {
  minRows?: number;
  maxRows?: number;
  width?: string;
};

export function DataInputTextarea({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  ariaLabelledBy,
  minRows = 2,
  maxRows = 4,
  width = '280px',
}: DataInputTextareaProps) {
  return (
    <Textarea
      value={String(inputValue || '')}
      onChange={e => setInputValue(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      minRows={minRows}
      maxRows={maxRows}
      autosize
      variant={variant}
      autoFocus={autoFocus}
      styles={{ input: { width } }}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
